import GlobalSettings from "@/services/resources/GlobalSettings"

const actions = {
    async checkFeatureEnabled({ commit, rootGetters }, keyFeatureEnabled='GENERAL_INFORMATION_ENABLED' ) {
      console.log('checkFeatureEnabled executando', keyFeatureEnabled)
      try {
        const serviceGlobalSettings = GlobalSettings.build();
        
        const response = await serviceGlobalSettings.search({ 
          keys: keyFeatureEnabled 
        })

        let featureEnabled = false;
        for (const item of response) {
          if (item.key === keyFeatureEnabled) {
            featureEnabled = item.value.trim() === '0' ? false : true;
          }          
          commit('setFeatureEnabled', featureEnabled)
          return featureEnabled;
        }

        commit('setFeatureEnabled', false)
        return false
        
      } catch (error) {
        console.error('Error checking feature enabled:', error)
        commit('setFeatureEnabled', false)
        return false
      }
    }
}

export default actions
